import Vue from 'vue';

Vue.component('stock-index', () =>
    import(/* webpackChunkName: 'stock-index' */ './stock-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock/index.js